module.exports = __webpack_public_path__ + "static/media/02.905149f9.jpg";